import { JobseekerFile } from './jobseeker-file';
import { JobseekerLanguageModel } from './jobseeker-language-model';
import { DrivingLicense } from '../../../shared/models/driving-license.model';
import { JobseekerWorkexperienceModel } from './jobseeker-workexperience-model';
import { Serializable } from '../../../core/models/serializable';
import { EventModel } from '@admin/jobseekers/shared/models/event.model';
import { OccupationCategorySelection } from '@admin/jobseekers/shared/models/occupation-category-selection';
import { JobseekerEducationModel } from '@admin/jobseekers/shared/models/jobseeker-education-model';
import { JobseekerExtendedLocationPath } from './jobseeke-extended-location-model';

export class JobseekerModel implements Serializable<JobseekerModel> {
  fromObject(obj: any): JobseekerModel {
    Object.assign(this, obj);
    this.educations = [];
    this.workExperiences = [];
    this.drivingLicenses = [];
    this.languages = [];
    this.documents = [];
    this.subscribedCategories = [];

    this.visitedEvents = [];

    if (obj.educations && obj.educations.length && obj.educations.length > 0) {
      obj.educations.forEach((w) => {
        let t = new JobseekerEducationModel();
        t = t.fromObject(w);
        this.educations.push(t);
      });
    }

    if (
      obj.workExperiences &&
      obj.workExperiences.length &&
      obj.workExperiences.length > 0
    ) {
      obj.workExperiences.forEach((w) => {
        let t = new JobseekerWorkexperienceModel();
        t = t.fromObject(w);
        this.workExperiences.push(t);
      });
    }

    if (
      obj.drivingLicenses &&
      obj.drivingLicenses.length &&
      obj.drivingLicenses.length > 0
    ) {
      obj.drivingLicenses.forEach((w) => {
        let t = new DrivingLicense();
        t = t.fromObject(w);
        this.drivingLicenses.push(t);
      });
    }

    if (obj.languages && obj.languages.length && obj.languages.length > 0) {
      obj.languages.forEach((w) => {
        let t = new JobseekerLanguageModel();
        t = t.fromObject(w);
        this.languages.push(t);
      });
    }

    if (obj.documents && obj.documents.length && obj.documents.length > 0) {
      obj.documents.forEach((w) => {
        let t = new JobseekerFile();
        t = t.fromObject(w);
        this.documents.push(t);
      });
    }

    if (
      obj.visitedEvents &&
      obj.visitedEvents.length &&
      obj.visitedEvents.length > 0
    ) {
      obj.visitedEvents.forEach((w) => {
        let t = new EventModel();
        t = t.fromObject(w);
        this.visitedEvents.push(t);
      });
    }

    if (
      obj.subscribedCategories &&
      obj.subscribedCategories.length &&
      obj.subscribedCategories.length > 0
    ) {
      obj.subscribedCategories.forEach((c) => {
        let t = new OccupationCategorySelection();
        t = t.fromObject(c);
        this.subscribedCategories.push(t);
      });
    }

    //TODO fill related data via
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public jobseekerId: number;
  public name: string;
  public surname: string;
  public genderId: number;
  public cityId: number;
  public cityName: string;
  public birthDay: string;
  public birthMonth: string;
  public birthYear: string;
  public birthDate: string;
  public email: string;
  public username: string;
  public phone: string;
  public phone2: string;
  public address: string;
  public photoHref: string;
  public hasPhoto: boolean;
  public activationLink: string;
  public registrationDate: Date;
  public lastUpdateDate: Date;
  public lastLoginDate: Date;
  public privacyName: string;
  public profileStateName: string;
  public numberOfAppliedVacancies: number;
  public numberOfAppliedCvBoxes: number;
  public logoFileName: string;
  public providerWebsiteId: number;
  public providerWebsiteName: string;
  public isInternalEmployee: boolean;
  public languageId: string;
  public photoFileName: string;
  public hasPendingChanges: boolean;

  public status: string; //TODO status name

  public get fullName() {
    return `${this.name} ${this.surname}`;
  }

  public educations: JobseekerEducationModel[];
  public workExperiences: JobseekerWorkexperienceModel[];
  public drivingLicenses: DrivingLicense[];
  public languages: JobseekerLanguageModel[];
  public documents: JobseekerFile[];
  public visitedEvents: EventModel[];

  public dailyDigestOn: boolean;
  public subscribedCategories: OccupationCategorySelection[];
  public subscribedLocalities: number[];

  public jobseekerExtendedLocations: string[];
  public extendedLocationPath: JobseekerExtendedLocationPath;
  public extendedLocationId: string;

  public isWorkExperienceFilled: boolean;
  public totalWorkExperienceYears: number;
  public totalWorkExperienceMonths: number;

  public getBasicInfo() {
    return {
      jobseekerId: this.jobseekerId,
      name: this.name,
      surname: this.surname,
      phone: this.phone,
      phone2: this.phone2,
      email: this.email,
    };
  }

  public getDetails() {}

  constructor() {
    this.educations = [];
    this.workExperiences = [];
    this.drivingLicenses = [];
    this.languages = [];
    this.documents = [];
  }
}
